import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'

const styles = {
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    padding: '4px 10px',
    borderRadius: 999,
    fontSize: '0.78rem',
    fontWeight: 600,
    whiteSpace: 'nowrap',
  },
  dot: {
    width: 7,
    height: 7,
    borderRadius: '50%',
    flexShrink: 0,
  },
}

const tones = {
  good: { color: '#15803d', bg: '#dcfce7', dot: '#22c55e' },
  warn: { color: '#b45309', bg: '#fef3c7', dot: '#f59e0b' },
  bad: { color: '#b91c1c', bg: '#fee2e2', dot: '#ef4444' },
  muted: { color: '#64748b', bg: '#f1f5f9', dot: '#94a3b8' },
  info: { color: '#0369a1', bg: '#e0f2fe', dot: '#38bdf8' },
}

function StatusBadge({ classes, label, tone = 'muted', icon }) {
  const t = tones[tone] || tones.muted
  return (
    <span className={classes.root} style={{ color: t.color, backgroundColor: t.bg }}>
      {icon || <span className={classes.dot} style={{ backgroundColor: t.dot }} />}
      {label}
    </span>
  )
}

StatusBadge.propTypes = {
  classes: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  tone: PropTypes.oneOf(['good', 'warn', 'bad', 'muted', 'info']),
  icon: PropTypes.node,
}

export default withStyles(styles)(StatusBadge)
